export const isNumber = (value: any) => {
  return typeof value === 'number';
};

export const extractNumberFromString = (str: string) => {
  const regex = /[^0-9]/g;

  return Number(str.replace(regex, ''));
};
